import React, { useEffect, useState, useCallback, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { isEqual } from 'lodash'
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import RepurchaseRateTable from './RepuchaseRateTable';
import RepurchaseRateShow from './RepurchaseRateShow';
import { getRepurchaseRateData, handleLoader } from '../../../../redux/actions/RepurchaseRateAction';
import { months } from '../../CompareMonth/helper';
import { setCurrencyFormat, findMonthsBetweenDates } from '../../../../utils/helpers';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import {
  filterShowWiseWithoutSKU as filterShowWise, filterMonthYearQuarterly,
  vendorNameMapping, sortType
} from '../../helper';

const quarterlyMonth = ['Jan-Feb-Mar', 'Apr-May-Jun', 'Jul-Aug-Sep', 'Oct-Nov-Dec']


const RepurchaseRate = ({ dispatch, rtl, vendor }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const currentYear = moment().format('YYYY');
  const preYear = moment().subtract(1, 'years').format('YYYY');
  const currentMonth = moment().format('MMM');
  const prevMonth = moment().subtract(5, 'months').format('MMM');

  const { repurchaseRateData, salesChannelFilterData, isLoading } = useSelector(
    ({ repurchaseRateReducer, marketPlaceReducer }) =>
    ({
      repurchaseRateData: repurchaseRateReducer?.[vendor]?.repurchaseRateData,
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      isLoading: repurchaseRateReducer?.[vendor]?.isLoading
    })
  );

  const salesChannelRef = useRef({})

  const [dataToShow, setDataToShow] = useState(repurchaseRateData?.modal?.data?.[0]?.yearlySales);
  const [showMarketPlaceMessage, setShowMarketPlaceMessage] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0])
  const [maxValueObj, setMaxValueObj] = useState({})
  const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth })
  const [month1, setMonth1] = useState({ year: preYear, month: prevMonth });
  const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
  const [tempMonth1, setTempMonth1] = useState({ year: preYear, month: prevMonth })
  const [selectedShowOptions, setSelectedShowOptions] = useState(filterMonthYearQuarterly?.[0]);

  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const monthOptions = months.map(item => ({ label: item, value: item }));

  const date1 = `${month1?.year}-${month1?.month}`;
  const date2 = `${month2?.year}-${month2?.month}`;
  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    const dvChartV = document.getElementById('dvChartView');
    dvTb.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `${vendorNameMapping[vendor]} Repuchase Rate Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
    dvChartV.style.display = "block"; 
  }

  const callApi = () => {
    const monthFromInt = moment().month(tempMonth1?.month).format('MM');
    const monthToInt = moment().month(tempMonth2?.month).format('MM');
    const lastDay = moment(new Date(tempMonth2.year, monthToInt - 1, 1)).endOf('month').format("DD");
    const noDaysInMonth = moment(tempMonth2?.month, "MMM").daysInMonth();
    const fromdate = moment(new Date(tempMonth1.year, monthFromInt - 1, 1)).format("YYYY-MM-DD");
    const todate = moment(new Date(tempMonth2.year, monthToInt - 1, noDaysInMonth)).format("YYYY-MM-DD");
    setShowMarketPlaceMessage(false)
    dispatch(handleLoader(true, vendor));
    dispatch(getRepurchaseRateData({
      fromDate: fromdate,
      toDate: todate,
      salesChannel: vendor === 'shopify' ? ['shopify.com'] : filterData?.salesChannel?.map(item => item.value) || [],
      productCategorizationBasedOn: currentlyShow?.value,
      vendor
    }));
  }

  const handleApplyDate = () => {
    const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
    const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

    const monthsBetween = findMonthsBetweenDates(startDate, endDate);
    if (monthsBetween?.length > 0) {
      setMonth1(tempMonth1);
      setMonth2(tempMonth2);
      setMaxValueObj({})

      callApi();
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Please select minumum two months'
        });
      });
    }
  }

  const handleYearMonthChange = ({ isFrom, field, value }) => {

    if (isFrom) {
      setTempMonth1({ ...tempMonth1, [field]: value?.value });
    } else {
      setTempMonth2({ ...tempMonth2, [field]: value?.value })
    }
  }

  const setMaxValue = useCallback((val) => {
    if (!maxValueObj[val]) {
      setMaxValueObj({ ...maxValueObj, [val]: Number(val) })
    }
  }, [maxValueObj])

  const getMonths = (start, end) =>
    Array.from({ length: end.diff(start, 'month') + 1 }).map((_, index) =>
      moment(start).add(index, 'month').format('MMM-YYYY'));

  const getYears = (start, end) =>
    Array.from({ length: end.diff(start, 'year') + 1 }).map((_, index) =>
      moment(start).add(index, 'year').format('YYYY'));

  const selectedFromMonth = month1.month;
  const selectedFromYear = month1.year;
  const selectedToMonth = month2.month;
  const selectedToYear = month2.year;

  const selectFromDate = selectedFromMonth + selectedFromYear;
  const selectToDate = selectedToMonth + selectedToYear;

  const selectedMonths = getMonths(moment(selectFromDate, 'MMMYYYY'), moment(selectToDate, 'MMMYYYY'))
  const selectedYears = getYears(moment(selectedFromYear, 'YYYY'), moment(selectedToYear, 'YYYY'))
  // eslint-disable-next-line react/prop-types
  const RenderYearAndMonth = ({ isFrom }) => (
    <Col sm="12" md="3">
      <Row className="justify-content-space-between">
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Year</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                  : { value: tempMonth2?.year, label: tempMonth2?.year }}
                options={yearOptions}
                clearable={false}
                placeholder="Select Year"
                className="select_filter-80"
                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'from' : 'to'}
              />
            </div>

          </div>
        </Col>
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Month</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                  : { value: tempMonth2?.month, label: tempMonth2?.month }}
                options={monthOptions}
                clearable={false}
                placeholder="Select Month"
                className="select_filter-80"
                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'fromMonth' : 'toMonth'}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );

  const changeFilter = (value) => {
    setCurrentlyShow(value)
  };

  const changeFilterForShow = (value) => {
    setSelectedShowOptions(value)
  };

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(repurchaseRateData?.modal?.data?.[0]?.yearlySales);
  }, [repurchaseRateData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && !isEqual(salesChannelFilterData, salesChannelRef?.current?.salesChannel || [])) {
      setShowMarketPlaceMessage(true)
      salesChannelRef.current = { [OptChennel]: salesChannelFilterData }
      setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  let dataToShowForDatesSelected = [];

  const monthsBetweenDates = findMonthsBetweenDates(date1, date2);
  for (let i = 0; i < monthsBetweenDates.length; i += 1) {
    const [year, month] = monthsBetweenDates?.[i]?.split('-');
    const monthWiseData = dataToShow?.[year]?.monthlyProductSales?.[month] ?? [];
    if (monthWiseData) {
      dataToShowForDatesSelected = dataToShowForDatesSelected?.concat(monthWiseData);
    }
  }

  const getTableHeader = () => {
    let header;
    if (selectedShowOptions.value === 'monthly') {
      header = selectedMonths;
    }
    else if (selectedShowOptions.value === 'yearly') {
      header = selectedYears;
    }
    else if (selectedShowOptions.value === 'quarterly') {
      const selectedQuarterlyMonth = [];
      selectedYears.forEach((item) => {
        quarterlyMonth.forEach((qItem) => {
          selectedQuarterlyMonth.push(`${qItem}-${item}`)
        })
      })
      header = selectedQuarterlyMonth;
    }

    return header;
  }

  const tableHeader = [{
    Header: 'Date',
    accessor: 'date',
    disableGlobalFilter: false,
    width: 120,
    sortType
  },
  {
    Header: currentlyShow?.value,
    accessor: 'category',
    disableGlobalFilter: false,
    width: 150,
    sortType
  },
  {
    Header: 'Repeat Customer',
    accessor: 'repeatCustomer',
    disableGlobalFilter: false,
    width: 120,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { repeatCustomer } = original
      return setCurrencyFormat(Number(repeatCustomer).toFixed(0), false)
    },
    sortType
  }, {
    Header: 'Total Customer',
    accessor: 'totalCustomer',
    disableGlobalFilter: false,
    width: 120,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { totalCustomer } = original
      return setCurrencyFormat(Number(totalCustomer).toFixed(0), false)
    }, sortType
  }, {
    Header: 'Repurchase rate(%)',
    accessor: 'repurchaseRate',
    disableGlobalFilter: false,
    width: 120,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { repurchaseRate } = original
      return `${setCurrencyFormat(Number(repurchaseRate).toFixed(2), false)} %`
    }, sortType
  }]

  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        View Report
      </button>
    </div>
  )
  const allCategories = {}
  const currentDataByCategory = {};

  const modalData = dataToShowForDatesSelected?.map(item => ({
    ...item,
    repeatCustomer: Number(item.repeatCustomer),
    date: `${item.month}-${item.year}`,
    totalCustomer: Number(item.totalCustomer),
    repurchaseRate: Number(((item.repeatCustomer / item.totalCustomer) * 100)),
  }))

  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">{vendorNameMapping[vendor]} Repuchase Rate</h5>
              </div>
              <Row className="justify-content-space-between align-items-center">
                <Col sm="6" md="2">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Show</span>
                    <div className="form__form-group-field">
                      <Select
                        value={currentlyShow}
                        options={filterShowWise}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter-150"
                        onChange={value => changeFilter(value)}
                        classNamePrefix="react-select"
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="6" md="2">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Type</span>
                    <div className="form__form-group-field">
                      <Select
                        value={selectedShowOptions}
                        options={filterMonthYearQuarterly}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter"
                        onChange={changeFilterForShow}
                        classNamePrefix="react-select"
                      // isMulti
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="12" md="8">
                  <Row className="justify-content-right align-items-center ">
                    <RenderYearAndMonth isFrom />
                    <Col sm='1' className="filter-to-position">~</Col>
                    <RenderYearAndMonth />
                    <Col sm="5" className="p-0 filter-to-position">
                      <button className="btn btn-sm btn-primary
                                             apply-date-button"
                        type="button" onClick={handleApplyDate}>
                        Apply</button>
                        <button className="btn btn-sm btn-primary
                                             apply-date-button"   type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                    </Col>                    
                  </Row>
                </Col>
                <Col sm="12">
                  <span style={{ color: 'red', alignItems: 'right' }}>
                    {showMarketPlaceMessage ? <small>*Hit Apply to fetch latest data </small> : ''}</span>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div id="divToPrint" ref={container}>
      <Card className="pb-3">
        <CardBody className="">
          <div className="top-location"
            style={{ minHeight: '400' }}>
            <div >
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                : <RepurchaseRateTable
                  dataToShowForDatesSelected={dataToShowForDatesSelected}
                  month={getTableHeader()}
                  // month={selectedShowOptions.value === 'yearly' ? selectedYears : 
                  // selectedShowOptions.value === 'monthly' ? selectedMonths : quarterlyMonth}
                  categorisedBasedOn={currentlyShow?.value}
                  title={`Repurchase Rate by ${selectedShowOptions?.label} and ${currentlyShow?.label}`}
                  firstColumn={currentlyShow?.label}
                  currentlyShow={currentlyShow}
                  optionShow={selectedShowOptions}
                />}
            </div>
          </div>
        </CardBody>
      </Card>
      <Card className="pb-3">
        <CardBody className="">
          <div className="top-location"
            style={{ minHeight: '400' }}>
            <div >
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                : <RepurchaseRateShow
                  dir={rtl.direction}
                  data={dataToShowForDatesSelected}
                  title={`Repurchase Rate By ${selectedShowOptions?.label}`}
                  viewReportButton={viewReportButton}
                  optionShow={selectedShowOptions}
                  month={getTableHeader()}
                />}
            </div>
          </div>
        </CardBody>
      </Card>
      </div>
      <ViewSalesReportModal
        modalData={modalData}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
        title='Repuchase Rate Report'
        fileName='Repuchase Rate Report'
      />
    </Container>
  );
};

RepurchaseRate.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
  vendor: PropTypes.number.isRequired
}

export default connect(state => ({
  rtl: state.rtl,
}))(RepurchaseRate);